// extracted by mini-css-extract-plugin
export var article_main = "styles-module--article_main--2aDSs";
export var article_title = "styles-module--article_title--2IDCR";
export var article_text = "styles-module--article_text--3WQSr";
export var article_categories = "styles-module--article_categories--32_xv";
export var article_categories_list = "styles-module--article_categories_list--32MGC";
export var article_socials = "styles-module--article_socials--1sjDC";
export var article_socials_title = "styles-module--article_socials_title--1MpmA";
export var article_list = "styles-module--article_list--3UP51";